import { render } from "./ElencoPresenze.vue?vue&type=template&id=fd1e3a24&scoped=true"
import script from "./ElencoPresenze.vue?vue&type=script&lang=ts"
export * from "./ElencoPresenze.vue?vue&type=script&lang=ts"

import "./ElencoPresenze.vue?vue&type=style&index=0&id=fd1e3a24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd1e3a24"

export default script